<template>
  <div>
    <slot>
        <TheHeader />
    </slot>
    <div v-if="isLoaded && config.error" class="componata-container">
      <FlashMessage type="error">
      Dieser Link ist ungültig. Bitte wenden Sie sich an Ihren Ansprechpartner.
    </FlashMessage>
    </div>
    <div class="componata-container" v-if="confirmed">
      <FlashMessage type="info">
        <p>{{ config.success }}</p>
      </FlashMessage>
    </div>
    <div v-if="isLoaded && !config.error && !confirmed" class="componata-container">
      <h1>{{ config.heading }}</h1>
      <slot v-if="isLoaded">
              <div v-html="config.note" class="content">
              </div>
      </slot>
      <h3>Empfängeradresse</h3>
        <div class="grid">
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("name1") }}</label>
                        <input
                          @focusout="validate"
                          type="text"
                          name="Empfänger Name 1"
                          :id="address+'#name1'"
                          v-model="address['name1']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("name2") }}</label>
                        <input
                          type="text"
                          :id="address+'#name2'"
                          v-model="address['name2']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("name3") }}</label>
                        <input
                          type="text"
                          :id="address+'#name3'"
                          v-model="address['name3']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("street") }}</label>
                        <input
                          @focusout="validate"
                          type="text"
                          :id="address+'#street'"
                          v-model="address['street']"
                          class="form-control"
                        />
                    </div>
                    </div>
                    <div class="col-1">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("hn") }}</label>
                        <input
                          @focusout="validate"
                          type="text"
                          :id="address+'#hn'"
                          v-model="address['hn']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-1">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("zip") }}</label>
                        <input
                          @focusout="validate"
                          type="text"
                          :id="address+'#zip'"
                          v-model="address['zip']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("city") }}</label>
                        <input
                          @focusout="validate"
                          type="text"
                          :id="address+'#city'"
                          v-model="address['city']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("country") }}</label>
                        <select
                          @focusout="validate"
                          :id="address+'#country'"
                          v-model="address['country']"
                          class="form-control"
                        >
                        <option v-for="option in countries" :value="option.value" :key="option.value">
                          {{ option.text }}
                        </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>{{ getAddressFieldString("mail") }}</label>
                        <input
                          type="text"
                          @focusout="validate"
                          :id="address+'#mail'"
                          v-model="address['mail']"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <slot>
                    <FlashMessage v-if="address.missing.length > 0" type="warning">
                      <p>{{ config.reqdata }}</p>
                      <ul>
                        <li class="missing-info" v-for="missing in address.missing" :key="missing">
                          {{ getAddressFieldString(missing) }}
                        </li>
                      </ul>
                    </FlashMessage>
                  </slot>
                  <div v-html="config.dataprotection"></div><input v-model="dataprotection" type="checkbox"><br /><br />
                  <input
                    type="button"
                    :value="config.submit"
                    @click="submit"
                  />
    </div>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader';
import { logicMixin } from '@/mixins/LogicMixin';
import { LoaderMixin } from '@/mixins/LoaderMixin';
import Vue from 'vue';
import axios from 'axios';
import FlashMessage from '@/components/Composer/FlashMessage';
Vue.component('modal', {
  template: '#modal-template'
});
export default {
  name: 'AddressInputService',
  mixins: [logicMixin, LoaderMixin],
  components: {
    TheHeader,
    FlashMessage
  },
  data () {
    return {
      isLoaded: false,
      config: {},
      address: {
        missing: ['name1', 'street', 'hn', 'zip', 'city', 'country', 'mail']
      },
      dataprotection: false,
      showModal: false,
      confirmed: false,
      customerName: '',
      customerMail: '',
      composerData: {},
      quantity: 0,
      box: '',
      weight: '',
      composerDelTime: '',
      selectedDate: new Date(),
      shippingAddress: {},
      orderId: '',
      boxKey: '',
      done: false,
      required: ['name1', 'street', 'hn', 'zip', 'city', 'country', 'mail'],
      countries: [
        { value: 'AF', text: 'Afghanistan' },
        { value: 'EG', text: 'Ägypten' },
        { value: 'AL', text: 'Albanien' },
        { value: 'DZ', text: 'Algerien' },
        { value: 'AD', text: 'Andorra' },
        { value: 'AO', text: 'Angola' },
        { value: 'AI', text: 'Anguilla' },
        { value: 'AQ', text: 'Antarktis' },
        { value: 'AG', text: 'Antigua und Barbuda' },
        { value: 'GQ', text: 'Äquatorial Guinea' },
        { value: 'AR', text: 'Argentinien' },
        { value: 'AM', text: 'Armenien' },
        { value: 'AW', text: 'Aruba' },
        { value: 'AZ', text: 'Aserbaidschan' },
        { value: 'ET', text: 'Äthiopien' },
        { value: 'AU', text: 'Australien' },
        { value: 'BS', text: 'Bahamas' },
        { value: 'BH', text: 'Bahrain' },
        { value: 'BD', text: 'Bangladesh' },
        { value: 'BB', text: 'Barbados' },
        { value: 'BE', text: 'Belgien' },
        { value: 'BZ', text: 'Belize' },
        { value: 'BJ', text: 'Benin' },
        { value: 'BM', text: 'Bermudas' },
        { value: 'BT', text: 'Bhutan' },
        { value: 'MM', text: 'Birma' },
        { value: 'BO', text: 'Bolivien' },
        { value: 'BA', text: 'Bosnien-Herzegowina' },
        { value: 'BW', text: 'Botswana' },
        { value: 'BV', text: 'Bouvet Inseln' },
        { value: 'BR', text: 'Brasilien' },
        { value: 'IO', text: 'Britisch-Indischer Ozean' },
        { value: 'BN', text: 'Brunei' },
        { value: 'BG', text: 'Bulgarien' },
        { value: 'BF', text: 'Burkina Faso' },
        { value: 'BI', text: 'Burundi' },
        { value: 'CL', text: 'Chile' },
        { value: 'CN', text: 'China' },
        { value: 'CX', text: 'Christmas Island' },
        { value: 'CK', text: 'Cook Inseln' },
        { value: 'CR', text: 'Costa Rica' },
        { value: 'DK', text: 'Dänemark' },
        { value: 'DE', text: 'Deutschland' },
        { value: 'DJ', text: 'Djibuti' },
        { value: 'DM', text: 'Dominika' },
        { value: 'DO', text: 'Dominikanische Republik' },
        { value: 'EC', text: 'Ecuador' },
        { value: 'SV', text: 'El Salvador' },
        { value: 'CI', text: 'Elfenbeinküste' },
        { value: 'ER', text: 'Eritrea' },
        { value: 'EE', text: 'Estland' },
        { value: 'FK', text: 'Falkland Inseln' },
        { value: 'FO', text: 'Färöer Inseln' },
        { value: 'FJ', text: 'Fidschi' },
        { value: 'FI', text: 'Finnland' },
        { value: 'FR', text: 'Frankreich' },
        { value: 'GF', text: 'französisch Guyana' },
        { value: 'PF', text: 'Französisch Polynesien' },
        { value: 'TF', text: 'Französisches Süd-Territorium' },
        { value: 'GA', text: 'Gabun' },
        { value: 'GM', text: 'Gambia' },
        { value: 'GE', text: 'Georgien' },
        { value: 'GH', text: 'Ghana' },
        { value: 'GI', text: 'Gibraltar' },
        { value: 'GD', text: 'Grenada' },
        { value: 'GR', text: 'Griechenland' },
        { value: 'GL', text: 'Grönland' },
        { value: 'GB', text: 'Großbritannien (UK)' },
        { value: 'GP', text: 'Guadeloupe' },
        { value: 'GU', text: 'Guam' },
        { value: 'GT', text: 'Guatemala' },
        { value: 'GN', text: 'Guinea' },
        { value: 'GW', text: 'Guinea Bissau' },
        { value: 'GY', text: 'Guyana' },
        { value: 'HT', text: 'Haiti' },
        { value: 'HM', text: 'Heard und McDonald Islands' },
        { value: 'HN', text: 'Honduras' },
        { value: 'HK', text: 'Hong Kong' },
        { value: 'IN', text: 'Indien' },
        { value: 'ID', text: 'Indonesien' },
        { value: 'IQ', text: 'Irak' },
        { value: 'IR', text: 'Iran' },
        { value: 'IE', text: 'Irland' },
        { value: 'IS', text: 'Island' },
        { value: 'IL', text: 'Israel' },
        { value: 'IT', text: 'Italien' },
        { value: 'JM', text: 'Jamaika' },
        { value: 'JP', text: 'Japan' },
        { value: 'YE', text: 'Jemen' },
        { value: 'JO', text: 'Jordanien' },
        { value: 'YU', text: 'Jugoslawien' },
        { value: 'KY', text: 'Kaiman Inseln' },
        { value: 'KH', text: 'Kambodscha' },
        { value: 'CM', text: 'Kamerun' },
        { value: 'CA', text: 'Kanada' },
        { value: 'CV', text: 'Kap Verde' },
        { value: 'KZ', text: 'Kasachstan' },
        { value: 'KE', text: 'Kenia' },
        { value: 'KG', text: 'Kirgisistan' },
        { value: 'KI', text: 'Kiribati' },
        { value: 'CC', text: 'Kokosinseln' },
        { value: 'CO', text: 'Kolumbien' },
        { value: 'KM', text: 'Komoren' },
        { value: 'CG', text: 'Kongo' },
        { value: 'CD', text: 'Kongo, Demokratische Republik' },
        { value: 'HR', text: 'Kroatien' },
        { value: 'CU', text: 'Kuba' },
        { value: 'KW', text: 'Kuwait' },
        { value: 'LA', text: 'Laos' },
        { value: 'LS', text: 'Lesotho' },
        { value: 'LV', text: 'Lettland' },
        { value: 'LB', text: 'Libanon' },
        { value: 'LR', text: 'Liberia' },
        { value: 'LY', text: 'Libyen' },
        { value: 'LI', text: 'Liechtenstein' },
        { value: 'LT', text: 'Litauen' },
        { value: 'LU', text: 'Luxemburg' },
        { value: 'MO', text: 'Macao' },
        { value: 'MG', text: 'Madagaskar' },
        { value: 'MW', text: 'Malawi' },
        { value: 'MY', text: 'Malaysia' },
        { value: 'MV', text: 'Malediven' },
        { value: 'ML', text: 'Mali' },
        { value: 'MT', text: 'Malta' },
        { value: 'MP', text: 'Marianen' },
        { value: 'MA', text: 'Marokko' },
        { value: 'MH', text: 'Marshall Inseln' },
        { value: 'MQ', text: 'Martinique' },
        { value: 'MR', text: 'Mauretanien' },
        { value: 'MU', text: 'Mauritius' },
        { value: 'YT', text: 'Mayotte' },
        { value: 'MK', text: 'Mazedonien' },
        { value: 'MX', text: 'Mexiko' },
        { value: 'FM', text: 'Mikronesien' },
        { value: 'MZ', text: 'Mocambique' },
        { value: 'MD', text: 'Moldavien' },
        { value: 'MC', text: 'Monaco' },
        { value: 'MN', text: 'Mongolei' },
        { value: 'MS', text: 'Montserrat' },
        { value: 'NA', text: 'Namibia' },
        { value: 'NR', text: 'Nauru' },
        { value: 'NP', text: 'Nepal' },
        { value: 'NC', text: 'Neukaledonien' },
        { value: 'NZ', text: 'Neuseeland' },
        { value: 'NI', text: 'Nicaragua' },
        { value: 'NL', text: 'Niederlande' },
        { value: 'AN', text: 'Niederländische Antillen' },
        { value: 'NE', text: 'Niger' },
        { value: 'NG', text: 'Nigeria' },
        { value: 'NU', text: 'Niue' },
        { value: 'KP', text: 'Nord Korea' },
        { value: 'NF', text: 'Norfolk Inseln' },
        { value: 'NO', text: 'Norwegen' },
        { value: 'OM', text: 'Oman' },
        { value: 'AT', text: 'Österreich' },
        { value: 'PK', text: 'Pakistan' },
        { value: 'PS', text: 'Palästina' },
        { value: 'PW', text: 'Palau' },
        { value: 'PA', text: 'Panama' },
        { value: 'PG', text: 'Papua Neuguinea' },
        { value: 'PY', text: 'Paraguay' },
        { value: 'PE', text: 'Peru' },
        { value: 'PH', text: 'Philippinen' },
        { value: 'PN', text: 'Pitcairn' },
        { value: 'PL', text: 'Polen' },
        { value: 'PT', text: 'Portugal' },
        { value: 'PR', text: 'Puerto Rico' },
        { value: 'QA', text: 'Qatar' },
        { value: 'RE', text: 'Reunion' },
        { value: 'RW', text: 'Ruanda' },
        { value: 'RO', text: 'Rumänien' },
        { value: 'RU', text: 'Russland' },
        { value: 'LC', text: 'Saint Lucia' },
        { value: 'ZM', text: 'Sambia' },
        { value: 'AS', text: 'Samoa' },
        { value: 'WS', text: 'Samoa' },
        { value: 'SM', text: 'San Marino' },
        { value: 'ST', text: 'Sao Tome' },
        { value: 'SA', text: 'Saudi Arabien' },
        { value: 'SE', text: 'Schweden' },
        { value: 'CH', text: 'Schweiz' },
        { value: 'SN', text: 'Senegal' },
        { value: 'SC', text: 'Seychellen' },
        { value: 'SL', text: 'Sierra Leone' },
        { value: 'SG', text: 'Singapur' },
        { value: 'SK', text: 'Slowakei' },
        { value: 'SI', text: 'Slowenien' },
        { value: 'SB', text: 'Solomon Inseln' },
        { value: 'SO', text: 'Somalia' },
        { value: 'GS', text: 'South Georgia, South Sandwich Isl.' },
        { value: 'ES', text: 'Spanien' },
        { value: 'LK', text: 'Sri Lanka' },
        { value: 'SH', text: 'St. Helena' },
        { value: 'KN', text: 'St. Kitts Nevis Anguilla' },
        { value: 'PM', text: 'St. Pierre und Miquelon' },
        { value: 'VC', text: 'St. Vincent' },
        { value: 'KR', text: 'Süd Korea' },
        { value: 'ZA', text: 'Südafrika' },
        { value: 'SD', text: 'Sudan' },
        { value: 'SR', text: 'Surinam' },
        { value: 'SJ', text: 'Svalbard und Jan Mayen Islands' },
        { value: 'SZ', text: 'Swasiland' },
        { value: 'SY', text: 'Syrien' },
        { value: 'TJ', text: 'Tadschikistan' },
        { value: 'TW', text: 'Taiwan' },
        { value: 'TZ', text: 'Tansania' },
        { value: 'TH', text: 'Thailand' },
        { value: 'TP', text: 'Timor' },
        { value: 'TG', text: 'Togo' },
        { value: 'TK', text: 'Tokelau' },
        { value: 'TO', text: 'Tonga' },
        { value: 'TT', text: 'Trinidad Tobago' },
        { value: 'TD', text: 'Tschad' },
        { value: 'CZ', text: 'Tschechische Republik' },
        { value: 'TN', text: 'Tunesien' },
        { value: 'TR', text: 'Türkei' },
        { value: 'TM', text: 'Turkmenistan' },
        { value: 'TC', text: 'Turks und Kaikos Inseln' },
        { value: 'TV', text: 'Tuvalu' },
        { value: 'UG', text: 'Uganda' },
        { value: 'UA', text: 'Ukraine' },
        { value: 'HU', text: 'Ungarn' },
        { value: 'UY', text: 'Uruguay' },
        { value: 'UZ', text: 'Usbekistan' },
        { value: 'VU', text: 'Vanuatu' },
        { value: 'VA', text: 'Vatikan' },
        { value: 'VE', text: 'Venezuela' },
        { value: 'AE', text: 'Vereinigte Arabische Emirate' },
        { value: 'US', text: 'Vereinigte Staaten von Amerika' },
        { value: 'VN', text: 'Vietnam' },
        { value: 'VG', text: 'Virgin Island (Brit.)' },
        { value: 'VI', text: 'Virgin Island (USA)' },
        { value: 'WF', text: 'Wallis et Futuna' },
        { value: 'BY', text: 'Weissrussland' },
        { value: 'EH', text: 'Westsahara' },
        { value: 'CF', text: 'Zentralafrikanische Republik' },
        { value: 'ZW', text: 'Zimbabwe' },
        { value: 'CY', text: 'Zypern' }
      ]
    };
  },
  methods: {
    init () {
    },
    addressValidation () {
      var tempMissing = [];
      this.required.forEach(element => {
        if (!(element in this.address)) {
          tempMissing.push(element);
        } else if (this.address[element] === '') {
          tempMissing.push(element);
        }
      });
      this.address.missing = tempMissing;
    },
    validate (e) {
      this.addressValidation();
    },
    submit() {
      if (!this.dataprotection) {
        alert('Bitte akzeptieren Sie die Datenschutzbestimmungen');
        return;
      }
      if ('missing' in this.address && this.address.missing.length === 0) {
        delete this.address.missing;
        delete this.address.index;
        var ret = {
          receiverAddress: this.address,
          inputPageKey: this.$route.params.key,
          mail: this.address.mail,
          name: this.address.name1
        };
        axios.post(process.env.VUE_APP_API_URL + '/setAddressInputService', JSON.stringify(ret)).then(response => {
          if (response.data.state === 'success') {
            this.confirmed = true;
          } else if (response.data.state === 'double') {
            alert(this.config.mailerror);
          } else {
            alert(this.config.generror);
          }
        });
      } else {
        alert(this.config.missingerror);
      }
    },
    getAddressFieldString(id) {
      if (id in this.config) {
        return this.config[id];
      }
      switch (id) {
        case 'name1':
          return 'Empfänger Name 1';
        case 'name2':
          return 'Empfänger Name 2';
        case 'name3':
          return 'Empfänger Name 3';
        case 'street':
          return 'Straße';
        case 'hn':
          return 'Hausnummer';
        case 'zip':
          return 'Postleitzahl';
        case 'city':
          return 'Ort';
        case 'country':
          return 'Land';
        case 'mail':
          return 'E-Mail';
      }
    }
  },
  created () {
    this.init();
    axios
      .get(process.env.VUE_APP_API_URL + '/addressinputservice/' + this.$route.params.key)
      .then((selfserviceRes) => {
        try {
          this.config = JSON.parse(selfserviceRes.data.config);
          this.isLoaded = true;
          this.config.error = false;
          if (!('heading' in this.config)) {
            this.config.error = true;
          }
        } catch (er) {
          this.isLoaded = true;
          this.config.error = true;
        }
      });
  }

};

</script>

<style scoped>

.previewImage {
  max-width: 20%;
}
.text-box {
  background-color: aliceblue;
  font-style: italic;
}
.content {
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  padding: 5px;
  margin-bottom: 5px;
}

.form-control {
  border-radius: 0.25rem;
  border: 1px solid #c4cdd5;
  box-shadow: inset 0 1px 2px 0 rgba(99,115,129,.2);
  width: 100%;
}

</style>
